export interface CalendarEvent {
  id: number;
  title: string;
  titleKey?: string;
  description?: string;
  descriptionKey?: string;
  startDate: Date;
  endDate: Date;
  allDay: boolean;
  location?: string;
  locationKey?: string;
  category: string;
  createdBy: number;
  createdDate: Date;
  updatedDate: Date;
  isRecurring: boolean;
  recurringPattern?: string;
  attendees?: number[];
  isPublic: boolean;
  reminderMinutes?: number;
  color?: string;
}

export const MOCK_CALENDAR_EVENTS: CalendarEvent[] = [
  {
    id: 1,
    titleKey: 'calendar.community-bbq',
    title: 'calendar.community-bbq',
    descriptionKey: 'calendar.community-bbq-description',
    description: 'calendar.community-bbq-description',
    startDate: new Date('2024-02-03T17:00:00Z'),
    endDate: new Date('2024-02-03T20:00:00Z'),
    allDay: false,
    locationKey: 'calendar.building-courtyard',
    location: 'calendar.building-courtyard',
    category: 'Community Event',
    createdBy: 1,
    createdDate: new Date('2024-01-15T14:30:00Z'),
    updatedDate: new Date('2024-01-15T14:30:00Z'),
    isRecurring: true,
    recurringPattern: 'monthly',
    attendees: [1, 2, 3, 4, 5],
    isPublic: true,
    reminderMinutes: 60,
    color: '#FF6B6B',
  },
  {
    id: 2,
    titleKey: 'calendar.pool-maintenance',
    title: 'calendar.pool-maintenance',
    descriptionKey: 'calendar.pool-maintenance-description',
    description: 'calendar.pool-maintenance-description',
    startDate: new Date('2024-01-25T09:00:00Z'),
    endDate: new Date('2024-01-25T15:00:00Z'),
    allDay: false,
    locationKey: 'calendar.swimming-pool',
    location: 'calendar.swimming-pool',
    category: 'Maintenance',
    createdBy: 1,
    createdDate: new Date('2024-01-20T10:00:00Z'),
    updatedDate: new Date('2024-01-20T10:00:00Z'),
    isRecurring: false,
    attendees: [],
    isPublic: true,
    reminderMinutes: 1440,
    color: '#4ECDC4',
  },
  {
    id: 3,
    titleKey: 'calendar.board-meeting',
    title: 'calendar.board-meeting',
    descriptionKey: 'calendar.board-meeting-description',
    description: 'calendar.board-meeting-description',
    startDate: new Date('2024-01-30T19:00:00Z'),
    endDate: new Date('2024-01-30T21:00:00Z'),
    allDay: false,
    locationKey: 'calendar.conference-room-a',
    location: 'calendar.conference-room-a',
    category: 'Meeting',
    createdBy: 1,
    createdDate: new Date('2024-01-10T09:00:00Z'),
    updatedDate: new Date('2024-01-10T09:00:00Z'),
    isRecurring: true,
    recurringPattern: 'monthly',
    attendees: [1, 2, 3],
    isPublic: false,
    reminderMinutes: 30,
    color: '#45B7D1',
  },
  {
    id: 4,
    titleKey: 'calendar.fitness-class-yoga',
    title: 'calendar.fitness-class-yoga',
    descriptionKey: 'calendar.fitness-class-yoga-description',
    description: 'calendar.fitness-class-yoga-description',
    startDate: new Date('2024-01-22T18:00:00Z'),
    endDate: new Date('2024-01-22T19:30:00Z'),
    allDay: false,
    locationKey: 'calendar.fitness-center',
    location: 'calendar.fitness-center',
    category: 'Fitness',
    createdBy: 2,
    createdDate: new Date('2024-01-15T16:00:00Z'),
    updatedDate: new Date('2024-01-15T16:00:00Z'),
    isRecurring: true,
    recurringPattern: 'weekly',
    attendees: [2, 4, 5],
    isPublic: true,
    reminderMinutes: 15,
    color: '#96CEB4',
  },
  {
    id: 5,
    titleKey: 'calendar.emergency-drill',
    title: 'calendar.emergency-drill',
    descriptionKey: 'calendar.emergency-drill-description',
    description: 'calendar.emergency-drill-description',
    startDate: new Date('2024-02-10T10:00:00Z'),
    endDate: new Date('2024-02-10T11:00:00Z'),
    allDay: false,
    locationKey: 'calendar.building-lobby',
    location: 'calendar.building-lobby',
    category: 'Safety',
    createdBy: 1,
    createdDate: new Date('2024-01-18T11:00:00Z'),
    updatedDate: new Date('2024-01-18T11:00:00Z'),
    isRecurring: false,
    attendees: [1, 2, 3, 4, 5],
    isPublic: true,
    reminderMinutes: 1440,
    color: '#FFEAA7',
  },
];
